/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/OnePageCheckout',[
    'jquery',
    'lodash',
    'global/all',
    'modules/User/all',
    'modules/Cart/all',
    'modules/Impersonation/all',
    'modules/Checkout/PayPal',
    'modules/Checkout/OnePageCheckout.Forms',
    'global/RocAnalytics',
    'modules/GiftCards/GiftCards',
    'global/GoogleMapsLoader',
    'modules/Checkout/Terms',
    'modules/Checkout/FreightCollect',
    'modules/Checkout/OnePageCheckout.Extra',
    'plugins/jquery.proxyRequest',
    'plugins/jquery.rocparams',
], function ($, _, Roc, Users, Cart, Impersonation, PayPal, OnePageCheckoutForms, RocAnalytics, GiftCards, GoogleMapsLoader,Terms, FreightCollect, OnePageCheckoutExtra) {
    'use strict';

    var viewModel;
    var shippingAddressChangedTimeout = null;
    var processOrderRequest = {};
    var recipientContainers = {};
    var emailSignUp = null;
    var cfg = window.RocConfig;

    var forms = {
        selectedPaymentMethod: {
            Fields: [
                {
                    Name: 'Payment Method',
                    Field: '#hdnSelectedPaymentMethodId',
                    Param: 'paymentMethod',
                    Type: 'Hidden',
                    GetValueMethod: { fn: getSelectedPaymentMethodId }
                }
            ],
            Validate: true,
            RequestParam: 'savedPaymentMethodId',
            RequestParamType: 'SingleValue',
            ErrorMsg: 'Please select payment method or add a new one'
        },
        selectedPaymentType: OnePageCheckoutForms.selectedPaymentType
    };

    var selectors = {
        editAddress: '.editAddress',
        submitAddressForm: 'button[data-roc-action="submitAddressForm"]',
        cancelAddressForm: 'button[data-roc-action="cancelAddressForm"]',
        addShippingAddress: 'button[data-roc-action="addShippingAddress"]',
        useThisShippingMethod: '.useThisShippingMethod',
        useThisShippingAddress: '.useThisShippingAddress',
        saveCCForFuturePurchasesCheckbox: '#save-payment-method',
        saveCCForFuturePurchasesWrapper: '[data-roc-wrapper="saveCCWrapper"]',
        createAccountCheckbox: '#create-account',
        paymentMethodFormActionButtons: '[data-roc-field="PaymentMethodFormActionButtons"]',
    };

    var buttons = {
        address: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisShippingAddress',
                    text: 'Use this address'
                },
                btnSelected: {
                    cssClass: 'selectedShippingAddres',
                    text: 'Selected address'
                }
            }
        },
        shipping: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisShippingMethod',
                    text: 'Use this method'
                },
                btnSelected: {
                    cssClass: 'selectedShippingMethod',
                    text: 'Selected method'
                }
            },
        },
        // Begin Customization
        payment: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisPaymentType',
                    text: 'Use this method'
                },
                btnSelected: {
                    cssClass: 'selectedPaymentType',
                    text: 'Selected method'
                }
            }
        },
        shippingPayment: {
            btns: {
                btnUseThis: {
                    cssClass: 'useThisShippingPaymentMethod',
                    text: 'Use this method'
                },
                btnSelected: {
                    cssClass: 'selectedShippingPaymentMethod',
                    text: 'Selected method'
                }
            }
        }
        // End Customization
    };

    function getRecipientContainerById(recipientId) {
        if (recipientContainers.hasOwnProperty(recipientId)) {
            return recipientContainers[recipientId];
        } else {
            var container = $('div[data-recipient-id="' + recipientId + '"]');
            recipientContainers[recipientId] = container;
            return container;
        }
    }

    function getSelectedAddressBookId(recipient) {
        if (typeof recipient === 'string') {
            recipient = getRecipientContainerById(recipient);
        }
        return recipient.find('input.hdnSelectedShippingAddressBookId').val();
    }

    function getRecipientContainerByElement(target) {
        return $(target).closest('div.panel-secondary[data-recipient-id]');
    }

    function getShippingFormSelector(recipientId) {
        return '#shipping-address-form-' + recipientId;
    }

    function isShippingAddressFormActive(recipientId) {
        return $(getShippingFormSelector(recipientId)).is(':visible');
    }

    //#####################################
    // Recipients - SHIPPING
    //#####################################

    /**
    * Callback function for shipping address selection event (from existing address book entries)
    * @returns {} 
    */
    function recipientSelectedAddressEvt() {
        Roc.UI.btnUseThisClickEvt(buttons.address.btns, recipientSelectedAddressCallback, 'div[data-recipient-id]');
    }

    function getShippingRecipient() {
        return _.find(viewModel.order.recipients, { itemsDeliveryType: 'Shipping' });
    }

    function recipientSelectedAddressCallback(addressId, $itemSource) {
        var $recipientContainer = getRecipientContainerByElement($itemSource);
        var recipientId = $recipientContainer.attr('data-recipient-id');
        changeShippingFormVisibility(recipientId, false);
        updateShippingAddressWithAddressBook(addressId, recipientId);
        $recipientContainer.find('input.hdnSelectedShippingAddressBookId').val(addressId);
        updateAddressBooks();
        if (viewModel.isBillingSameAsShipping) {
            updateBillingAddressForm();
        }
    }

    function recipientWantsEditAddressBookEvt() {
        $(document)
            .off('click', selectors.editAddress)
            .on('click', selectors.editAddress, function () {
                var $recipientContainer = getRecipientContainerByElement(this);
                var recipientId = $recipientContainer.attr('data-recipient-id');
                var addressId = Roc.UI.getItemId(this);

                $recipientContainer.find('#shipping-address-form-' + recipientId).attr('data-edit-id', addressId);
                //$('div[data-recipient-id="' + recipientId + '"] #shipping-address-form-' + recipientId).attr('data-edit-id', addressId);\
                // 1. Unselect address book
                unSelectShippingAddress(recipientId);
                // 2. Close shipping forms for other recipients to avoid editing the same entry in two places
                _.forEach(viewModel.order.recipients, function (recipient) {
                    if (recipient.itemsDeliveryType === 'Virtual' || recipient.itemsDeliveryType === 'Pickup') {
                        // virtual and pickup recipients don't have shipping forms that can be hidden, skip them
                        return;
                    }

                    if (recipient.id !== recipientId) {
                        changeShippingFormVisibility(recipient.id, false);
                    }
                });
                // 3. Find recipient and address to edit
                var recipient = getRecipientById(recipientId);
                var address = _.find(recipient.addressBook, { 'id': addressId });
                Roc.Forms.populateData(address, forms['Recipient-' + recipientId].shippingAddressForm);
                // 4. Update label
                $recipientContainer.find('.panel-title .action').text('Update');
                // 5. Open shipping form
                changeShippingFormVisibility(recipientId, true);
                updateRecipientFormRegionStateDisplay(recipientId);
                // 6. update bindings related with country
                bindAddressAutoCompleteEvt(recipientId, address.country);
                bindZipCodeLookUpEvt(recipientId, address.country);
            });
    }

    function getRecipientById(recipientId) {
        return _.find(viewModel.order.recipients, { 'id': recipientId });
    }

    function recipientSavesChangesForAddressBookEvt() {
        $(document)
            .off('click', selectors.submitAddressForm)
            .on('click', selectors.submitAddressForm, function () {
                var $recipientContainer = getRecipientContainerByElement(this);
                var recipientId = $recipientContainer.attr('data-recipient-id');
                var addressId = $recipientContainer.find('#shipping-address-form-' + recipientId).attr('data-edit-id');

                var recipientForm = forms['Recipient-' + recipientId].shippingAddressForm; 
                    if (Roc.Validation.validateForm(recipientForm)) {
                        var data = Roc.Forms.getFormValues(recipientForm);
                        if (addressId) {
                            data.id = addressId;
                        }

                        Users.AddressBook.updateOrCreateAddressBook(data, function (xhr) {
                            var response = xhr.responseJSON || {};
                            if (xhr.status === 200 || xhr.status === 201) {
                                var address = response;
                                address.btnUseThis = buttons.address.btns.btnUseThis;
                                address.btnSelected = buttons.address.btns.btnSelected;
                                address.enableRemove = false;
                                address.enableDefaultSelection = false;
                                address.enableSelection = true;

                                if (addressId) {
                                    $.each(viewModel.addresses, function (i, v) {
                                        if (v.id === addressId) {
                                            viewModel.addresses[i] = address;
                                            _.forEach(viewModel.order.recipients, function (recipient) {
                                                $.each(recipient.addressBook, function (i, v) {
                                                    if (v.id === addressId) {
                                                        recipient.addressBook[i] = _.cloneDeep(address);
                                                        return;
                                                    }
                                                });
                                                //getRecipientContainerById(recipient.id).find('#shipping-address-list .item[data-id=' + addressId + ']').replaceWith(Roc.UI.templateV2('#address-Tmp', address));
                                            });
                                            return;
                                        }
                                    });
                                    $recipientContainer.find('#shipping-address-form-' + recipientId).attr('data-edit-id', '');
                                } else {
                                    viewModel.addresses.push(address);
                                    _.forEach(viewModel.order.recipients, function (recipient) {
                                        recipient.addressBook.push(address);

                                        Roc.UI.template('address-Tmp', address).then(function (renderedTemplate) {
                                            getRecipientContainerById(recipient.id).find('#shipping-address-list').append(renderedTemplate);
                                        });
                                    });
                                }
                                selectShippingAddress(address.id, recipientId);
                            } else {
                                Roc.UI.ajaxErrorPopup(xhr);
                            }
                        });
                    } 
            });
    }

    function recipientCancelsUpdatingAddressBookEvt() {
        $(document)
            .off('click', selectors.cancelAddressForm)
            .on('click', selectors.cancelAddressForm, function () {
                var $recipientContainer = getRecipientContainerByElement(this);
                var recipientId = $recipientContainer.attr('data-recipient-id');

                var addressId = $recipientContainer.find('#shipping-address-form-' + recipientId).attr('data-edit-id');
                if (addressId) {
                    selectShippingAddress(addressId, recipientId);
                }
                $recipientContainer.find('#shipping-address-form-' + recipientId).attr('data-edit-id', '');
                changeShippingFormVisibility(recipientId, false);
            });
    }

    function recipientWantsProvideNewAddressEvt() {
        $(document)
            .off('click', selectors.addShippingAddress)
            .on('click', selectors.addShippingAddress, function () {
                var $recipientContainer = getRecipientContainerByElement(this);
                var recipientId = $recipientContainer.attr('data-recipient-id');
                unSelectShippingAddress(recipientId);
                shippingAddressChangesByUpdatingDataManaully(recipientId);
                changeShippingFormVisibility(recipientId, true);
                updateRecipientFormRegionStateDisplay(recipientId);
                bindAddressAutoCompleteEvt(recipientId);
                bindZipCodeLookUpEvt(recipientId);
            });
    }

    function recipientSelectedShippingMethodEvt() {
        Roc.UI.btnUseThisClickEvt(buttons.shipping.btns, function (serviceId, $itemSource) {
            var $recipientContainer = getRecipientContainerByElement($itemSource);
            var recipientId = $recipientContainer.attr('data-recipient-id');
            var addressBookId = getSelectedAddressBookId(recipientId);
            var shippingAddressForm = forms['Recipient-' + recipientId].shippingAddressForm;

            //we allow to update shipping without triggering / presenting validation to the user
            //at the same time we don't want to send invalid fields to WebAPI so we extract only valid ones
            var validShippingAddressFields = Roc.Validation.getValidFieldValues(shippingAddressForm);

            var shippingRequest = Roc.Core.cloneJsObject(validShippingAddressFields);
            shippingRequest.shippingServiceId = serviceId;
            shippingRequest.recipientId = recipientId;
            shippingRequest.addressBookId = addressBookId;

            $recipientContainer.find('input.hdnSelectedShippingMethodId').val(serviceId);
            Roc.UI.block();
            Cart.CartManager.updateShippingDetails(shippingRequest, Roc.Enums.shippingRequestType.BOTH);
        }, 'div[data-recipient-id]');
    } 

    function recipientSelectedShippingPaymentMethodEvt() {
        Roc.UI.btnUseThisClickEvt(buttons.shippingPayment.btns, function (shippingPaymentType, $itemSource) {
            var $recipientContainer = getRecipientContainerByElement($itemSource);
            var recipientId = $recipientContainer.attr('data-recipient-id');
            var recipient = getRecipientById(recipientId);
            var addressBookId = getSelectedAddressBookId(recipientId);
            var shippingAddressForm = forms['Recipient-' + recipientId].shippingAddressForm;
            var validShippingAddressFields = Roc.Validation.getValidFieldValues(shippingAddressForm);
            var serviceId = $recipientContainer.find('input.hdnSelectedShippingMethodId').val();

            $recipientContainer.find('input.hdnShippingPaymentMethodId').val(shippingPaymentType);

            if (shippingPaymentType) {
                recipient.shippingPaymentMethodOption = shippingPaymentType;

                var shippingRequest = Roc.Core.cloneJsObject(validShippingAddressFields);
                shippingRequest.shippingServiceId = serviceId;
                shippingRequest.recipientId = recipientId;
                shippingRequest.addressBookId = addressBookId;
                shippingRequest.shippingPaymentMethodOption = shippingPaymentType;
                
                Roc.UI.block();
                Cart.CartManager.updateShippingDetails(shippingRequest, Roc.Enums.shippingRequestType.BOTH);
            }    
        }, 'div[data-recipient-id]');
    }

    /**
     * @param {} recipientId 
     * @returns {} 
     */
    function unSelectShippingAddress(recipientId) {
        var $recipientContainer = getRecipientContainerById(recipientId);
        $recipientContainer.find('input.hdnSelectedShippingAddressBookId').val('');
        Roc.UI.swapButtons(buttons.address.btns, null, 'div[data-recipient-id="' + recipientId + '"]');
        updateAddressBooks();
    }

    function selectShippingAddress(addressId, recipientId) {
        var $recipientContainer = $('div[data-recipient-id="' + recipientId + '"]');
        $recipientContainer.find('#shipping-address-list .item[data-id="' + addressId + '"] ' + selectors.useThisShippingAddress).trigger('click');
    }


    /**
     * Uses CartManager to send reuqest to the api with shipping details (either address book entry or address data from form fields)
     * @param {} data 
     * @returns {} 
     */
    function updateShippingDetails(data, requestCustomFields) {
        Roc.UI.block();
        Cart.CartManager.updateShippingDetails(data, Roc.Enums.shippingRequestType.UPDATE_ADDRESS, requestCustomFields);
    }


    /**
     * Wrapper function for calling updateShippingDetails with parameters declared explicitly
     * @param {} addressId 
     * @param {} recipientId 
     * @returns {} 
     */
    function updateShippingAddressWithAddressBook(addressId, recipientId) {
        updateShippingDetails({ recipientId: recipientId, addressBookId: addressId });
    }


    function addCountyToAddress(address) {
        if (address && address.customFields && address.customFields.county) {
            address.county = address.customFields.county;
        }
    }
    /**
     * Callback function for CartManager event which is triggered after updating shipping address
     * @param {} xhr 
     * @returns {} 
     */
    function shippingRecalculated(data) {
        var xhr = data.xhr;
        var request = data.request;
        var recipientId = request.recipientId;

        var response = xhr.responseJSON;
        if (xhr.status === 200) {
            var recipient = getRecipientById(recipientId);        
            recipient.shippingOptions = response.recipient.shippingOptions;
            recipient.shippingPaymentOptions = response.recipient.shippingPaymentOptions;
            recipient.allShippingMethodsBlocked = response.recipient.allShippingMethodsBlocked;
            recipient.shippingPaymentMethodOption = response.recipient.shippingPaymentMethodOption;

            prepareRecipientShippingOptionsViewModel(recipient);
            // prepare errors for recipient after shopping cart recalculation

            // Begin Customization
            var $recipientContainer = getRecipientContainerById(recipientId);
            recipient.recalculateErrors = response.errors;
            recipient.shippingServiceId = response.recipient.shippingServiceId;
        
            reloadRecipients(recipient, $recipientContainer);
            // End Customization
        } else if (response.message) {
            if (response.message === 'Your order cart inventory have changed') {
                redirectToCart(xhr);
            } else {
                Roc.UI.ajaxErrorPopup(xhr);
            }
        }

        Roc.UI.unblock();
    }


    // Begin Customization
    function reloadRecipients(recipient, $recipientContainer) {
        // render shipping options section
        Roc.UI.template('shippingMethods-Tmp', recipient).then(function (renderedTemplate) {
            $recipientContainer.find('.shipping-methods-list').html(renderedTemplate);
        });

        Roc.UI.template('onePageCheckoutShippingMethodOptionForm-Tmp', recipient).then(function (renderedTemplate) {
            $recipientContainer.find('.shipping-payment-methods-list').html(renderedTemplate);
            if (recipient.shippingPaymentMethodOption) {
                $recipientContainer.find('input.hdnShippingPaymentMethodId').val(recipient.shippingPaymentMethodOption);
            }
        });
        
        Roc.UI.template('recipientErrors-Tmp', recipient).then(function (renderedTemplate) {
            $recipientContainer.find('.recipient-errors').html(renderedTemplate);
        });

        $recipientContainer.find('.hdnSelectedShippingMethodId').val(recipient.shippingServiceId);

        //show shippingPaymentMethod form
        if (recipient.shippingServiceId) {
            var selectorForSPO = '#shippingPaymentMethodOptionForm-' + recipient.id;
            $(selectorForSPO).show();
        }

        if (recipient.shippingPaymentMethodOption) {
            var fieldContainer = $recipientContainer.find("div.accountNumberDiv");
            var selectedShippingPaymentOptions = _.find(recipient.shippingPaymentOptions, { key: recipient.shippingPaymentMethodOption });
            if (selectedShippingPaymentOptions && selectedShippingPaymentOptions.showField) {
                fieldContainer.show();
            } else {
                fieldContainer.hide();
            }
        }

        // update label
        updateRecipientStepLabel(recipient);
    }
    // End Customization

        function updateRecipientStepLabel(recipient) {
            try {
                if (recipient.shippingMethod !== undefined && recipient.shippingMethod !== null) {
                    RocAnalytics.recordShipppingStep(viewModel.order.items, recipient.shippingMethod);
                }
            }
            catch (err) {
            }
            getRecipientContainerById(recipient.id).find('span.recipient-label').text(recipient.label);
        }

    /**
     * Wrapper function for calling updateShippingDetails - it grabs all data from form fields and creates JSON object
     * @param {} recipientId 
     * @returns {} 
     */
    function updateShippingAddressWithFormData(recipientId) {
        var recipientForm = forms['Recipient-' + recipientId].shippingAddressForm;
        var addressData = Roc.Forms.getFormValues(recipientForm);

        var country = _.find(viewModel.countries, { enableShipping: true, countryCode: addressData.country });
        var isZipCorrectlySet = addressData.hasOwnProperty('zip') && country && (!country.isPostalCodeRequired || (country.isPostalCodeRequired && addressData.zip));
        if (!isZipCorrectlySet || !addressData.country || !addressData.address1 || !addressData.city || (addressData.country === 'US' && !addressData.state)) {
            return; //exit because there is no enough data to calculate shipping rates
        }

        var requestData = {
            recipientId: recipientId,
            zip: addressData.zip,
            state: addressData.state,
            country: addressData.country,
            firstName: addressData.firstName,
            lastName: addressData.lastName,
            address1: addressData.address1,
            address2: addressData.address2,
            city: addressData.city,
            region: addressData.region,
            company: addressData.company
        };

        updateShippingDetails(requestData);
    }

    /**
     * Adds 1 second delay before updating recipient's shipping address with form data.
     * This is to give some time when user may want change it again - it avoids requesting api unnecessarily in that case
     * @param {} recipientId 
     * @returns {} 
     */
    function shippingAddressChangesByUpdatingDataManaully(recipientId) {
        if (shippingAddressChangedTimeout !== null) {
            clearTimeout(shippingAddressChangedTimeout);
        }
        shippingAddressChangedTimeout = setTimeout(function () {
            updateShippingAddressWithFormData(recipientId);
        }, 1000);
    }

    function changeShippingFormVisibility(recipientId, visible) {
        var shippingFormSelector = getShippingFormSelector(recipientId);
        if (visible) {
            Roc.UI.openForm(shippingFormSelector);
            Roc.UI.scrollTo(shippingFormSelector, -60);
        } else {
            var shippingAddressForm = forms['Recipient-' + recipientId].shippingAddressForm;
            Roc.UI.clearFormErrors(shippingAddressForm);
            Roc.UI.closeForm(shippingFormSelector);
            getRecipientContainerById(recipientId).find('.panel-title .action').text('Add');
            Roc.Forms.clearData(forms['Recipient-' + recipientId].shippingAddressForm);
            $('#country-' + recipientId).val(window.RocConfig.defaultCountryCode).trigger(Roc.Events.general.CHANGE);
        }

    }

    function updateSaveCCForFuturePurchasesDisplay() {
        var wrapperSelector = selectors.saveCCForFuturePurchasesWrapper;
        var $checkbox = $(selectors.saveCCForFuturePurchasesCheckbox);
        if (viewModel.isLoggedIn || createAccountChecked()) {
            $checkbox.closest(wrapperSelector).show();
        } else {
            $checkbox.prop('checked', false);
            $checkbox.closest(wrapperSelector).hide();
        }
    }

    function updateSameAsShippingDisplay() {
        var enableBilling = false;
        var recipient = getShippingRecipient();
        var addressBookId = getSelectedAddressBookId(recipient.id);
        if (addressBookId) {
            var addressBook = _.find(recipient.addressBook, { 'id': addressBookId });
            enableBilling = addressBook.enableBilling;
        } else {
            var $country = $('#country-' + recipient.id);
            var countryCode = $country.val();
            enableBilling = $country.find('option[value="' + countryCode + '"]').attr('data-enablebilling') === 'true';
        }

        var sameAsShipping = '[data-roc-wrapper="same-as-shipping"]';
        $(sameAsShipping).each(function () {
            if (enableBilling) {
                $(this).show();
            } else {
                $(this).hide();
                viewModel.isBillingSameAsShipping = false;
            }
        });
    }

    function bindAddressFormEvents(recipientId, country) {
        firstNameChangeEvt(recipientId);
        lastNameChangeEvt(recipientId);
        cityChangeEvt(recipientId);
        countryChangeEvt(recipientId);
        bindAddressAutoCompleteEvt(recipientId, country);
        bindZipCodeLookUpEvt(recipientId, country);
    }

    function wipeRecipientAddressValues(recipientId) {
        //wipe the values entered so far for address 1, address 2, city, state/region, zip.
        var recipientForms = forms['Recipient-' + recipientId];
        if (recipientForms && recipientForms.shippingAddressForm) {
            var fields = _.filter(recipientForms.shippingAddressForm.Fields, { WipeOnCountryChange: true });
            Roc.Forms.clearData({ Fields: fields });

            var $recipientContainer = getRecipientContainerById(recipientId);
            // hide shipping methods because address values have been wiped
            Roc.UI.template('shippingMethods-Tmp', null).then(function (renderedTemplate) {
                $recipientContainer.find('.shipping-methods-list').html(renderedTemplate);
            });
        }
    }


    function firstNameChangeEvt(recipientId) {
        var selector = '#first-name-' + recipientId;
        var recipient = getRecipientById(recipientId);

        $(document)
            .off('change', selector)
            .on('change', selector, function () {
                var $this = $(this);
                recipient.firstName = $this.val();
                recipient.label = Roc.UI.formatRecipientLabel(recipient);
                updateRecipientStepLabel(recipient);
                Roc.EventManager.notify(Roc.Events.checkout.UPDATE_RECIPIENT, recipient);
            });
    }

    function lastNameChangeEvt(recipientId) {
        var selector = '#last-name-' + recipientId;
        var recipient = getRecipientById(recipientId);

        $(document)
            .off('change', selector)
            .on('change', selector, function () {
                var $this = $(this);
                recipient.lastName = $this.val();
                recipient.label = Roc.UI.formatRecipientLabel(recipient);
                updateRecipientStepLabel(recipient);
                Roc.EventManager.notify(Roc.Events.checkout.UPDATE_RECIPIENT, recipient);
            });
    }

    function cityChangeEvt(recipientId) {
        var selector = '#city-' + recipientId;
        var recipient = getRecipientById(recipientId);
        var changeEventNamespace = '.onePageCheckout-cityChangeEvt';
        var changeEventArray = ['change', 'change.jqueryziplookup', 'change.jqueryaddresscomplete'];
        var changeEvent = Roc.EventBuilder.buildName(changeEventArray, changeEventNamespace);
        Roc.UI.attachEventHandler(changeEvent, selector, function () {
            var $this = $(this);
            recipient.city = $this.val();
            recipient.label = Roc.UI.formatRecipientLabel(recipient);
            updateRecipientStepLabel(recipient);
            Roc.EventManager.notify(Roc.Events.checkout.UPDATE_RECIPIENT, recipient);
        });
    }

    function countryChangeEvt(recipientId) {
        var selector = '#country-' + recipientId;
        var changeEventWithNamespace = 'change.onePageCheckout-countryChangeEvt';
        var focusEventWithNamespace = 'focus.onePageCheckout-countryChangeEvt';

        $(document)
            .off(focusEventWithNamespace, selector)
            .on(focusEventWithNamespace, selector, function () {
                var $this = $(this);
                $this.setRocParam('previousCode', $this.val());
            });


        $(document)
            .off(changeEventWithNamespace, selector)
            .on(changeEventWithNamespace, selector, function () {
                var countryCode = $(this).val();
                var previousCode = $(this).getRocParam('previousCode');
                if (previousCode !== countryCode) {
                    $('#state-' + recipientId).val('');
                    wipeRecipientAddressValues(recipientId); // wipe address values if user changes country on checkout
                    updateRecipientFormRegionStateDisplay(recipientId);
                    bindAddressAutoCompleteEvt(recipientId, countryCode);
                    bindZipCodeLookUpEvt(recipientId, countryCode);
                    updateSameAsShippingDisplay();
                    shippingAddressChanged();
                }
                $(this).setRocParam('previousCode', countryCode);
            });
    }

    function updateRecipientFormRegionStateDisplay(recipientId) {
        var $country = $('#country-' + recipientId);
        var $regionWrapper = $('#region-wrapper-' + recipientId);
        var $regionInput = $('#region-' + recipientId);
        var $stateWrapper = $('#state-wrapper-' + recipientId);
        var $countyWrapper = $('#county-wrapper-' + recipientId);
        var $countyInput = $('#county-' + recipientId);
        updateRegionStateDisplay($country, $regionWrapper, $regionInput, $stateWrapper, $countyWrapper, $countyInput);
    }

    function updateBillingFormRegion() {
        var $country = $('#billing-country');
        var $regionWrapper = $('#billing-region-wrapper');
        var $regionInput = $('#billing-region');
        var $stateWrapper = $('#billing-state-wrapper');
        var $countyInput = $('#billing-county');
        var $countyWrapper = $('#billing-county-wrapper');
        updateRegionStateDisplay($country, $regionWrapper, $regionInput, $stateWrapper, $countyWrapper, $countyInput);
    }

    function updateRegionStateDisplay($country, $regionWrapper, $regionInput, $stateWrapper, $countyWrapper, $countyInput) {
        if ($country.val() === 'US' || $country.val() === 'CA') {
            $stateWrapper.show();
            $regionWrapper.hide();
            $regionInput.val('');
            $stateWrapper.find('[data-country]').hide();
            $stateWrapper.find('[data-country=' + $country.val() + ']').show();
        } else {
            $stateWrapper.hide();
            $regionWrapper.show();
        }
        
        if ($country.val() === 'US') {
            $countyWrapper.show();
        } else {
            $countyWrapper.hide();
            $countyInput.val('');
        }
    }

    function bindAddressAutoCompleteEvt(recipientId, country) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true) {
            return;
        }

        country = country || window.RocConfig.defaultCountryCode;
        Roc.UI.addresscomplete('#address1-' + recipientId, {
            country: country,
            autopopulate: true,
            fieldsMapping: {
                "STREET_ADDRESS_AND_NUMBER": '#address1-' + recipientId,
                "COUNTRY": '#country-' + recipientId,
                "ZIP": '#zip-' + recipientId,
                "CITY": '#city-' + recipientId,
                "STATE_OR_REGION": (country === 'US' || country === 'CA') ? '#state-' + recipientId : '#region-' + recipientId,
                "COUNTY": '#county-' + recipientId
            },
            validation: {
                componentsToValidate: ['street_number'],
                onValidationFailed: function (sender) {
                    var fieldDef = {
                        Field: '#' + sender.attr('id'),
                        Type: 'Text',
                        ErrorMsg: 'Address could not be validated, please confirm address is correct'
                    };
                    Roc.UI.showFormFieldError(fieldDef);
                    Roc.UI.disableAddressComplete(sender);
                }
            }
        });
    }

    function bindZipCodeLookUpEvt(recipientId, country) {
        if (window.RocConfig.google.enableAddressAutocomplete !== true) {
            return;
        }
        country = country || window.RocConfig.defaultCountryCode;
        Roc.UI.ziplookup('#zip-' + recipientId, {
            country: country,
            fieldsMapping: {
                "CITY": '#city-' + recipientId,
                "COUNTY": '#county-' + recipientId,
                "STATE_OR_REGION": (country === 'US' || country === 'CA') ? '#state-' + recipientId : '#region-' + recipientId
            }
        });
    }

    function prepareRecipientShippingOptionsViewModel(recipient) {

        if (!recipient.shippingAddressId) {
            addCountyToAddress(recipient);
            if (recipient.addressBook) {
                for (var i = 0; i < recipient.addressBook.length; i++) {
                    addCountyToAddress(recipient.addressBook[i]);
                }
            }
        }
        if (recipient.shippingOptions) {
            _.forEach(recipient.shippingOptions, function (shippingOption) {
                shippingOption.btnUseThis = {
                    cssClass: 'useThisShippingMethod',
                    text: 'Use this method'
                };
                shippingOption.btnSelected = {
                    cssClass: 'selectedShippingMethod',
                    text: 'Selected method'
                };
            });
        }

        if (recipient.shippingPaymentOptions) {
            _.forEach(recipient.shippingPaymentOptions, function (shippingPaymentOption) {
                shippingPaymentOption.btnUseThis = {
                    cssClass: buttons.shippingPayment.btns.btnUseThis.cssClass,
                    text: buttons.shippingPayment.btns.btnUseThis.text
                };
                shippingPaymentOption.btnSelected = {
                    cssClass: buttons.shippingPayment.btns.btnSelected.cssClass,
                    text: buttons.shippingPayment.btns.btnSelected.text
                };
            });
        }
    }

    function prepareRecipientRecalculateErrors(recipient, errors) {
        var recipientErrors = _.find(errors, {
            'recipientId': recipient.id
        });
        if (recipientErrors) {
            recipient.recalculateErrors = recipientErrors.errors;
        }
    }

    function initializeFormDefinitonsForRecipient(recipient, index) {
        if (!forms.hasOwnProperty('Recipient-' + recipient.id)) {

            var formDefinitions = null;
            switch (recipient.itemsDeliveryType) {
            case 'Shipping':
                var changeEventNamespace = '.onePageCheckout-initializeFormDefinitonsForRecipient';
                var changeEventArray = ['change', 'change.jqueryziplookup', 'change.jqueryaddresscomplete'];
                var changeEvent = Roc.EventBuilder.buildName(changeEventArray, changeEventNamespace); 
                var recipientShippingForm = _.cloneDeep(OnePageCheckoutForms.recipientShippingAddress);
                recipientShippingForm.RequestParam = 'shippingRecipients.' + recipient.id + '.shippingAddress';
                _.forEach(recipientShippingForm.Fields, function (n, k) {

                    //uppdate referenced field selectors
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);

                        // initialize shipping recalculation triggers
                        Roc.UI.attachEventHandler(changeEvent, n.Field, function (e) {
                            if (n.ShippingCalcReq) {
                                shippingAddressChangesByUpdatingDataManaully(recipient.id);
                            }
                            shippingAddressChanged(n);
                        });
                    }

                    // update referenced field selectors
                    if (n.Validators) {
                        _.forEach(n.Validators, function (v, l) {
                            if (v.ReferencedField) {
                                v.ReferencedField = v.ReferencedField.replace('{id}', recipient.id);
                            }
                            if (v.ConditionalField) {
                                v.ConditionalField = v.ConditionalField.replace('{id}', recipient.id);
                            }
                        });
                    }
                });

                var selectedShippingAddress = _.cloneDeep(OnePageCheckoutForms.recipientSelectedShippingAddress);
                selectedShippingAddress.RequestParam = 'shippingRecipients.' + recipient.id + '.shippingAddressId';
                _.forEach(selectedShippingAddress.Fields, function (n, k) {
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });
                selectedShippingAddress.ErrorMsg = selectedShippingAddress.ErrorMsg.replace('{step}', index + 1);

                var selectedShippingMethod = _.cloneDeep(OnePageCheckoutForms.selectedShippingMethod);
                selectedShippingMethod.RequestParam = 'shippingRecipients.' + recipient.id + '.shippingMethodId';
                _.forEach(selectedShippingMethod.Fields, function (n, k) {
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });
                selectedShippingMethod.ErrorMsg = selectedShippingMethod.ErrorMsg.replace('{step}', index + 1);
                
                var shippingPaymentMethodOption = _.cloneDeep(OnePageCheckoutForms.shippingPaymentMethodOption);
                shippingPaymentMethodOption.RequestParam = 'shippingRecipients.' + recipient.id + '.shippingPaymentMethodOption';
                _.forEach(shippingPaymentMethodOption.Fields, function (n, k) {
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });
                shippingPaymentMethodOption.ErrorMsg = shippingPaymentMethodOption.ErrorMsg.replace('{step}', index + 1);

                var recipientSelectedMissingAddressData = _.cloneDeep(OnePageCheckoutForms.recipientSelectedMissingAddressData);
                recipientSelectedMissingAddressData.RequestParam = 'shippingRecipients.' + recipient.id + '.missingAddressData';

                    _.forEach(recipientSelectedMissingAddressData.Fields, function (n, k) {
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });
                    recipientSelectedMissingAddressData.ErrorMsg = recipientSelectedMissingAddressData.ErrorMsg.replace('{step}', index + 1);

                var billMyAccountNumber = _.cloneDeep(OnePageCheckoutForms.billMyAccountNumber);
                billMyAccountNumber.RequestParam = 'shippingRecipients.' + recipient.id + '.billMyAccountNumber';
                _.forEach(billMyAccountNumber.Fields, function (n, k) {
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });

                formDefinitions = {
                    // definiton of shipping address form
                    'shippingAddressForm': recipientShippingForm,
                    // definiton of selected shipping address
                    'selectedShippingAddress': selectedShippingAddress,
                    // defitinion of selected shipping method
                    'selectedShippingMethod': selectedShippingMethod,
                    // defitinion of selected shipping payment method
                    'shippingPaymentMethodOption': shippingPaymentMethodOption,
                    'recipientSelectedMissingAddressData': recipientSelectedMissingAddressData,
                    'billMyAccountNumber': billMyAccountNumber,
                    'isGroup': true
                };

                if (recipient.shippingDeliveryCode === 'freight-collect') {
                    var freightCollectForm = _.cloneDeep(FreightCollect.forms.recipientFreightCollectData);
                    _.forEach(freightCollectForm.Fields, function (n, k) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    });
                    freightCollectForm.RequestParam = 'freightCollectRecipients.' + recipient.id;
                    forms['FreightCollect-' + recipient.id] = freightCollectForm;
                }

                break;
            case 'Pickup':
                var recipientPickupForm = _.cloneDeep(OnePageCheckoutForms.recipientStorePickupData);
                recipientPickupForm.RequestParam = 'pickupRecipients.' + recipient.id;
                _.forEach(recipientPickupForm.Fields, function (n, k) {
                    //uppdate referenced field selectors
                    if (n.Field) {
                        n.Field = n.Field.replace('{id}', recipient.id);
                    }
                });
                formDefinitions = recipientPickupForm;
                break;
            }
            forms['Recipient-' + recipient.id] = formDefinitions;
        }
    }

    /**
     * Based on data in the view/view model updates forms validation
     * @returns {} 
     */
    function updateFormsValidation() {
        if (viewModel.enableShipping) {
            _.forEach(viewModel.order.recipients, function (recipient) {
                if (recipient.itemsDeliveryType === 'Virtual') {
                    return;
                }

                var recipientForms = forms['Recipient-' + recipient.id];

                switch (recipient.itemsDeliveryType) {
                case 'Shipping':
                    if (getSelectedAddressBookId(recipient.id) || !isShippingAddressFormActive(recipient.id)) {
                        recipientForms.shippingAddressForm.Validate = false;
                        recipientForms.selectedShippingAddress.Validate = true;
                    } else {
                        recipientForms.shippingAddressForm.Validate = true;
                        recipientForms.selectedShippingAddress.Validate = false;
                    }
                        recipientForms.selectedShippingMethod.Validate = true;
                        //If there is shippingPaymentMethodOption then no need to validate them
                        if (recipient.shippingPaymentOptions) {
                            recipientForms.shippingPaymentMethodOption.Validate = true;
                        }
                        else {
                            recipientForms.shippingPaymentMethodOption.Validate = false;
                        }
                    break;
                case 'Pickup':
                    recipientForms.Validate = true;
                    break;
                } 
            });
        }

        forms.CreateAccount.Validate = !viewModel.isLoggedIn && createAccountChecked();
        forms.RecipientEmail.Validate = !viewModel.isLoggedIn && !createAccountChecked();

        if (viewModel.order.modifiedOrderTotal <= 0) {
            Roc.Validation.disableFormValidation(forms.CreditCard);
            if (viewModel.paymentMethods.newAddressFormActive()) {
                forms.CreditCard.BillingAddress.Validate = true;
                forms.CreditCard.selectedBillingAddress.Validate = false;
            } else {
                forms.CreditCard.BillingAddress.Validate = false;
                forms.CreditCard.selectedBillingAddress.Validate = true;
            }
            Roc.Validation.disableFormValidation(forms.PurchaseOrder);
            Roc.Validation.disableFormValidation(forms.PayPal);
            Roc.Validation.disableFormValidation(forms.selectedPaymentMethod);
            return;
        }

        switch (getSelectedPaymentType()) {
        case 'Credit Card':
            //Disable validation for PO forms
            Roc.Validation.disableFormValidation(forms.PurchaseOrder);
            Roc.Validation.disableFormValidation(forms.PayPal);

            if (getSelectedPaymentMethodId() || !paymentMethodFormActive()) {
                forms.selectedPaymentMethod.Validate = true;

                forms.CreditCard.AddPaymentMethod.Validate = false;
                forms.CreditCard.BillingAddress.Validate = false;
                forms.CreditCard.selectedBillingAddress.Validate = false;
            } else {
                forms.selectedPaymentMethod.Validate = false;

                forms.CreditCard.AddPaymentMethod.Validate = true;
                if (viewModel.paymentMethods.newAddressFormActive()) {
                    forms.CreditCard.BillingAddress.Validate = true;
                    forms.CreditCard.selectedBillingAddress.Validate = false;
                } else {
                    forms.CreditCard.BillingAddress.Validate = false;
                    forms.CreditCard.selectedBillingAddress.Validate = true;
                }
            }
            break;
        case 'Purchase Order':
            // Disable validation for CC forms
            Roc.Validation.disableFormValidation(forms.CreditCard);
            Roc.Validation.disableFormValidation(forms.PayPal);
            forms.selectedPaymentMethod.Validate = false;

            forms.PurchaseOrder.PurchaseOrder.Validate = true;
            var newBillingAddressForPo = Users.PurchaseOrder.newAddressFormActive();

            forms.PurchaseOrder.BillingAddress.Validate = newBillingAddressForPo;
            forms.PurchaseOrder.selectedBillingAddress.Validate = !newBillingAddressForPo;

            break;
        case 'PayPal':
            // Disable validation for CC and PO forms
            Roc.Validation.disableFormValidation(forms.CreditCard);
            Roc.Validation.disableFormValidation(forms.PurchaseOrder);
            forms.selectedPaymentMethod.Validate = false;

            forms.PayPal.PayPal.Validate = true;
            var newBillingAddressForPp = PayPal.newAddressFormActive();

            forms.PayPal.BillingAddress.Validate = newBillingAddressForPp;
            forms.PayPal.selectedBillingAddress.Validate = !newBillingAddressForPp;

            break;
        // Begin Customization
        case 'My Terms':
            // Disable validation for CC and PO forms
            Roc.Validation.disableFormValidation(forms.CreditCard);
            Roc.Validation.disableFormValidation(forms.PayPal);
            Roc.Validation.disableFormValidation(forms.PurchaseOrder);

            forms.selectedPaymentMethod.Validate = false;
            forms.Terms.Validate = true;
            forms.Terms.selectedBillingAddress.Validate = true; 
            break;
        }    
        // End Customization
    }

    function collectRequestData() {
        var result = {
            'data': {},
            'validationResult': true,
            'errors': []
        };

        updateFormsValidation();
        _.forEach(forms, function (definition, k) {
            if (definition && definition.isGroup) {
                _.forEach(definition, function (subFormDefinition) {
                    if (typeof subFormDefinition === 'object' && _.has(subFormDefinition, 'Fields')) {
                        if (!validateAndGetFormData(subFormDefinition, result.data, result.errors)) {
                            result.validationResult = false;
                        }
                    }
                });
            } else {
                if (typeof definition === 'object' && _.has(definition, 'Fields')) { 
                        if (!validateAndGetFormData(definition, result.data, result.errors)) {
                            result.validationResult = false;
                        } 
                }
            }
        });

        if (result.data) {
            if (result.data.billingAddress) {
                if (_.has(result.data.billingAddress, 'county')) {
                    countyToCustomField(result.data.billingAddress);
                }
            }

            if (result.data.shippingRecipients) {
                _.forEach(result.data.shippingRecipients,
                    function (value, key) {
                        if (_.has(value, 'shippingAddress') && _.has(value.shippingAddress, 'county')) {
                            countyToCustomField(value.shippingAddress);
                        } else {
                            if (_.has(value, 'missingAddressData') && _.has(value.missingAddressData, 'county')) {
                                value.county = value.missingAddressData.county;
                            }
                        }
                    });
            }
        }
        return result;
    }

    function countyToCustomField(address) {
        if (address && address.county) {
            address.customFields = {
                county: address.county
            };
        }
    }

    /**
     * Validates form based on provided form definition and returns object with data from form fields
     * @param {} form 
     * @returns {} 
     */
    function validateAndGetFormData(form, requestData, errorsArray) {
        var data = null;

        if (form.Validate) {
            var formValues = Roc.Forms.getFormValues(form);
            if (form.RequestParam) {
                if (form.RequestParamType === 'SingleValue') {
                    var keys = Object.keys(formValues);
                    data = formValues[keys[0]];
                } else if (form.RequestParamType === 'SpecificValue') {
                    // pull out the specific key rather than the first key
                    var key = form.RequestParam;
                    data = formValues[key];
                } else {
                    data = formValues;
                }
            } 
            var result = Roc.Validation.validateForm(form);
            if (!result) {
                if (form.ErrorMsg) {
                    errorsArray.push(form.ErrorMsg);
                }
                return false;
            }

            if (form.RequestParam) {
                var requestParamsObj = form.RequestParam.split('.');
                if (requestParamsObj.length === 1) {
                    requestData[requestParamsObj[0]] = data;
                } else {
                    var scopeObj = requestData;
                    _.forEach(requestParamsObj, function (param, index, array) {
                        if (!_.has(scopeObj, param)) {
                            scopeObj[param] = {};
                        }
                        if (index !== array.length - 1) {
                            scopeObj = scopeObj[param];
                        }
                    });
                    scopeObj[requestParamsObj[requestParamsObj.length - 1]] = data;
                }
            }
        }
        return true;
    }

    function updateAddressBooks() {
        var recipientsAndAddresses = _.map(viewModel.order.recipients, function (r) {
            var $recipientContainer = getRecipientContainerById(r.id);
            return {
                'recipientId': r.id,
                'addressBookId': getSelectedAddressBookId($recipientContainer)
            };
        });

        _.forEach(recipientsAndAddresses, function (o) {
            var recipient = _.find(viewModel.order.recipients, { 'id': o.recipientId });
            var $recipientContainer = getRecipientContainerById(recipient.id);
            recipient.addressBook = _.cloneDeep(viewModel.addresses);
            if (recipient.addressBook) {
                recipient.displayAddressBookEntries = true;

                var alreadySelectedAddresses = _.map(
                    _.pick(recipientsAndAddresses, function (ra) {
                            return ra.recipientId !== recipient.id;
                        }
                    ), 'addressBookId');

                _.forEach(recipient.addressBook, function (address) {
                    if (_.contains(alreadySelectedAddresses, address.id)) {
                        address.enableSelection = false;
                        address.enableEdit = false;
                        address.isAlreadyInUse = true;
                    }

                    if (o.addressBookId && o.addressBookId === address.id) {
                        address.isSelected = true;
                    }

                    if (!address.enableShipping) {
                        address.enableSelection = false;
                        address.enableEdit = false;
                        if (address.isSelected) {
                            var errorMessage = 'Currently we do not support shipping to country: ' + address.countryLabel;
                            if (address.state) {
                                errorMessage += ' and state with code: ' + address.state;
                            }
                            errorMessage += '. Please choose or add another address.';
                            Roc.UI.displayErrorPopup(errorMessage);
                        }
                    }

                    Roc.UI.template('address-Tmp', address).then(function (renderedTemplate) {
                        $recipientContainer.find('#shipping-address-list .item[data-id=' + address.id + ']').replaceWith(renderedTemplate);
                    });
                });
            } else {
                recipient.displayAddressBookEntries = false;
            }
            checkSelectedAddressMissingData(o.recipientId);
        });
    }

    function checkSelectedAddressMissingData(recipientId) {
        var $recipientContainer = getRecipientContainerById(recipientId);
        var missingFormSelector = getMissingDataFormSelector(recipientId);
        var recipient = getRecipientById(recipientId);
        var address = _.find(recipient.addressBook, { 'isSelected': true });

        if (address && address.isSelected && address.customFields && !address.customFields.county) {
            Roc.UI.template('onePageCheckoutAddressMissingData-Tmp', { recipientId: recipientId }).then(
                function(renderedTemplate) {
                    $recipientContainer.find(missingFormSelector).html(renderedTemplate);
                });
        } else {
            $recipientContainer.find(missingFormSelector).html("");
        }
    }

    function getMissingDataFormSelector(recipientId) {
        return '#shipping-address-missing-data-form-' + recipientId;
    }

    function viewRendered() {
        _.forEach(viewModel.order.recipients, function (recipient) {
            if (recipient.itemsDeliveryType === 'Virtual') {
                return;
            }

            if (!recipient.shippingAddressId) {
                Roc.Forms.populateData(recipient, forms['Recipient-' + recipient.id].shippingAddressForm || forms['Recipient-' + recipient.id]);
            }

            bindAddressFormEvents(recipient.id, recipient.shippingAddressId ? window.RocConfig.defaultCountryCode : recipient.country);
            updateRecipientFormRegionStateDisplay(recipient.id);
        });
        updateAddressBooks();
        updateBillingFormRegion();
        updateCheckoutSteps();
    }

    function updateCheckoutSteps() {
        //update step numbers.
        $('.stepNumberDisplay:visible').each(function (idx) {
            $(this).html(idx + 1);
        });
    }

    /* ---------------------------------------- Payments ------------------------------- */

    function paymentMethodSelectedEvt() {
        Roc.UI.btnUseThisClickEvt(viewModel.paymentMethods.btns, function (methodId) {
            Roc.UI.closeForm(viewModel.paymentMethods.formSelector);
        });
    }

    // Begin Customization
    function selectedPaymentMethodEvt() {
        Roc.EventManager.bind(Roc.Events.checkout.PAYMENT_TYPE_CHANGED, setSelectedPaymentType);
    }

    function setSelectedPaymentType(data) { 
        var orderId = $('.payment-selector').attr('data-roc-orderid'); 

        var request = {
            orderId: orderId,
            paymentTypeName: data.name,
            paymentType: data.paymentType
        };

        $.proxyRequest({
            url: 'api/store/cart/extra/setselectedpaymenttype',
            data: JSON.stringify(request),
            type: 'PUT',
            dataType: 'json',
            contentType: 'application/json',
            complete: function (xhr) { 
                Roc.UI.block();
                Roc.EventManager.notify(Roc.Events.cart.UPDATE_PAYMENT_DETAILS, { xhr: xhr, request: request });
            }
        });
    } 

    function updateRecipientsAfterChangingPaymentEvt() {
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_PAYMENT_DETAILS, updateRecipientsAfterChangingPayment);
    }

    function updateRecipientsAfterChangingPayment(data) {
        var xhr = data.xhr;

        var response = xhr.responseJSON;
        if (xhr.status === 200) {
            // find recipient and update shipping options
            if (response.orderCart) {
                _.forEach(response.orderCart.recipients, function (recipient) {
                    prepareRecipientShippingOptionsViewModel(recipient);
                    // prepare errors for recipient after shopping cart recalculation
                    var $recipientContainer = getRecipientContainerById(recipient.id);
                    reloadRecipients(recipient, $recipientContainer);
                });
            } 
        } else if (response.message) {
            if (response.message === 'Your order cart inventory have changed') {
                redirectToCart(xhr);
            } else {
                Roc.UI.ajaxErrorPopup(xhr);
            }
        }

        Roc.UI.unblock();
    }
    // End Customization

    function displayPaymentForm(paymentName) {
        var selectedPaymentType = _.find(viewModel.paymentTypes, { 'name': paymentName });
        if (selectedPaymentType) {
            Roc.EventManager.notify(Roc.Events.checkout.PAYMENT_TYPE_CHANGED, selectedPaymentType);
            $('.billing-form').addClass('hidden');
            $('.billing-form[data-payment-type="' + selectedPaymentType.name + '"]').removeClass('hidden'); 
            // Begin Customization
            $('#billing-payment-type').val(selectedPaymentType.name);
            // End Customization
        }
    }
    
    function paymentTypeSelectedEvt() {
        // Begin Customization
        Roc.UI.btnUseThisClickEvt(buttons.payment.btns, function (name) {
            viewModel.selectedPaymentType = name;
            displayPaymentForm(name);
        });
        // End Customization
    }

    function unSelectPaymentMethod() {
        Roc.UI.swapButtons(viewModel.paymentMethods.btns, null);
    }

    function selectPaymentMethod(paymentMethodId) {
        Roc.UI.swapButtons(viewModel.paymentMethods.btns, '[data-id=' + paymentMethodId + '] .' + viewModel.paymentMethods.btns.btnUseThis.cssClass);
    }

    function paymentMethodFormActive() {
        return $(viewModel.paymentMethods.formSelector).is(':visible');
    }

    function getSelectedPaymentType() {
        return Roc.Forms.getFormValues(forms.selectedPaymentType).paymentType;
    }

    function getSelectedPaymentMethodId() {
        return Roc.UI.getItemId('.' + viewModel.paymentMethods.btns.btnSelected.cssClass);
    }

    function reloadPaymentStep(viewModel) {
        Roc.UI.renderFormTemplate('onePageCheckoutPaymentStep-Tmp', viewModel, $('[data-roc-wrapper="payment-step"]')).then(function () {
            updateSameAsShippingDisplay();
            updateSaveCCForFuturePurchasesDisplay();
            Roc.UI.bindAddressFormEvents('billing');
            Roc.UI.bindAddressFormEvents('pp-billing');
            Roc.UI.bindAddressFormEvents('po-billing');
            PayPal.loadBillingData();
            updateBillingFormRegion();
            updateCheckoutSteps();
        });
    }

    /* ---------------------------------------- Payments ------------------------------- */

    /* ---------------------------------------- Registration ----------------------------*/
    function createAccountChecked() {
        return $(selectors.createAccountCheckbox).is(':checked');
    }

    function createAccountAndProcessOrder() {
        if (!Users.register()) {
            releaseLockedButtons();
        }
    }
    function updateAccountField(fieldName, billingAddressForm, registrationForm) {
        var billingField = _.find(billingAddressForm.Fields, {
            'Param': 'address.' + (fieldName === 'county' ? 'customFields.' + fieldName : fieldName)
        });
        if (!billingField) {
            billingField = _.find(billingAddressForm.Fields,
            {
                'Param': fieldName === 'county' ? 'customFields.' + fieldName : fieldName
            });
        }

        var field = _.find(registrationForm.Fields, {
            'Param': fieldName
        });
        field.Field = billingField.Field;
        field.ExcludeFromErrorSummary = true;
    }

    function getCreateAccountForm(billingAddressForm) {
        // update registration form fields to collect proper data from billing address form
        var form = Users.forms.Registration;


        updateAccountField('firstName', billingAddressForm, form);
        updateAccountField('lastName', billingAddressForm, form);
        updateAccountField('address1', billingAddressForm, form);
        updateAccountField('address2', billingAddressForm, form);
        updateAccountField('city', billingAddressForm, form);
        updateAccountField('state', billingAddressForm, form);
        updateAccountField('country', billingAddressForm, form);
        updateAccountField('county', billingAddressForm, form);
        updateAccountField('zip', billingAddressForm, form);
        updateAccountField('phone', billingAddressForm, form);
         
        form.RequestParam = 'email';
        form.RequestParamType = 'SpecificValue';
        return form;
    }

    function getEmailForm() {
        var form = _.cloneDeep(Users.forms.Email);
        form.RequestParam = 'email';
        form.RequestParamType = 'SingleValue';
        return form;
    }

    /* User Account functions */
    var signInFormSel = '#signInFormWrapper';
    var forgotPasswordFormSel = '#forgotPasswordFormWrapper';

    function forgotPasswordEvt() {
        Users.initForgotPassword({
            isRetrievalProcess: true
        });

        var selectorForgotPassword = '#forgotPasswordLink';
        var selectorForgotPasswordBack = '#forgotPasswordBackBtn';

        $(document).off('click', selectorForgotPassword).on('click', selectorForgotPassword, function () {
            $(signInFormSel).hide();
            $(forgotPasswordFormSel).show();
        });

        $(document).off('click', selectorForgotPasswordBack).on('click', selectorForgotPasswordBack, function () {
            $(signInFormSel).show();
            $(forgotPasswordFormSel).hide();
        });
    }

    function signInBtnEvt() {
        var selector = '#signInLink';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                var signInPopup = '#signInPopupWrapper';
                $(signInPopup).show();
                Roc.UI.Modal.open(signInPopup);
                $(signInFormSel).show();
                $(forgotPasswordFormSel).hide();
                //reset forgot password
                $('#forgotForm').show();
                $('#checkEmail').hide();
            });
    }

    function loginUserEvt() {
        var $loginContainer = $('#loginContainer');

        Users.initLogin({
            isCheckout: true,
            beforeSend: function () {
                Roc.UI.block($loginContainer);
            }
        });

        Roc.EventManager.bind(Roc.Events.users.LOGIN, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.checkoutViewModel) {
                buildViewModel(response.checkoutViewModel);
                Roc.UI.Modal.close();
            }
            Roc.UI.unblock($loginContainer);
        });
    }

    function logoutUserEvt() {
        var selector = '.logoutLink';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                Roc.UI.block('.roc-checkout');
                Users.logout('/ajax/Logout');
                Roc.EventManager.bind(Roc.Events.users.LOGOUT, function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.success) {
                        window.location.href = '/cart';
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                    }
                });
                return false;
            });
    }

    function createAccountEvt() {
        createAccountCheckBoxEvt();

        Users.initRegistration({
            duringCheckout: true
        });

        Roc.EventManager.bind(Roc.Events.users.REGISTER, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.userId) {
                viewModel.userId = response.userId;
                processOrder();
            } else {
                if (response.errorMessage) {
                    Roc.UI.displayErrorPopup(response.errorMessage);
                }
                releaseLockedButtons();
            }
        });
    }

    function createAccountCheckBoxEvt() {
        $(document)
            .off('click', selectors.createAccountCheckbox)
            .on('click', selectors.createAccountCheckbox, function () {
                var $registerFieldsWrapper = $('#registerFieldsWrapper');
                if ($(this).is(':checked')) {
                    $registerFieldsWrapper.show();
                } else {
                    $registerFieldsWrapper.hide();
                }
            });
    }

    /* Process Order functions */
    function lockProcessButtons() {
        Roc.Core.lockButton('#btnProcessOrder, #btnProcessOrderRail', 'Processing...');
    }

    function releaseLockedButtons() {
        Roc.Core.releaseLockedButton('#btnProcessOrder, #btnProcessOrderRail');
    }

    function redirectToCart(errors) {
        Roc.Core.createCookie('cart-msg', JSON.stringify(errors), 1);
        window.location.href = '/cart';
    }

    function countyFromCustomFields(addressBookEntry) {
        if (addressBookEntry && addressBookEntry.customFields && addressBookEntry.customFields.county) {
            addressBookEntry.county = addressBookEntry.customFields.county;
        }
    }

    function copyShippingAddressToBilling(checkbox, paymentModule) {
        var isChecked = $(checkbox).is(':checked');
        if (isChecked) {
            var recipient = getShippingRecipient();
            var addressBookId = getSelectedAddressBookId(recipient.id);
            if (addressBookId) {
                var addressBook = _.find(recipient.addressBook, { 'id': addressBookId });
                countyFromCustomFields(addressBook); 
                paymentModule.copyBillingFromAddressBook(addressBook);
            } else {
                paymentModule.copyBillingFromShipping(forms['Recipient-' + recipient.id].shippingAddressForm);
            }
        } else {
            paymentModule.clearBillingForm();
        }
    }

    function updateBillingAddressForm() {
        var paymentModule = null;

        var selectedPaymentType = getSelectedPaymentType();
        switch (selectedPaymentType) {
        case 'Credit Card':
            paymentModule = Users.PaymentMethods;
            break;
        case 'Purchase Order':
            paymentModule = Users.PurchaseOrder;
            break;
        case 'PayPal':
            break;
        }

        if (paymentModule) {
            if (viewModel.isBillingSameAsShipping) {
                var recipient = getShippingRecipient();
                var addressBookId = getSelectedAddressBookId(recipient.id);
                if (addressBookId) {
                    var addressBook = _.find(recipient.addressBook, { 'id': addressBookId });
                    countyFromCustomFields(addressBook); 
                    paymentModule.copyBillingFromAddressBook(addressBook);
                } else {
                    paymentModule.copyBillingFromShipping(forms['Recipient-' + recipient.id].shippingAddressForm);
                }
            } else {
                paymentModule.clearBillingForm();
            }
        }
    }

    function sameBillingAsShippingSelectedHandler(checkbox) {
        var isChecked = $(checkbox).is(':checked');
        viewModel.isBillingSameAsShipping = isChecked;
        updateBillingAddressForm();
    }

    function shippingAddressChanged() {
        if (viewModel.isBillingSameAsShipping) {
            updateBillingAddressForm();
        }
    }

    function sameBillingAddressEvt() {
        var selector = '[id$="billing-same-as-shipping"]';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                sameBillingAsShippingSelectedHandler(this);
            });
    }

    function processOrderEvt() {
        var selector = '#btnProcessOrder, #btnProcessOrderRail';

        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                var isSameAsShipping = false;
                var savePaymentMethod = false;
                emailSignUp = $('#email-signup').is(':checked');
                var paymentType = getSelectedPaymentType();
                switch (paymentType) {
                case 'Credit Card':
                    isSameAsShipping = $('#billing-same-as-shipping').is(':checked');
                    savePaymentMethod = $(selectors.saveCCForFuturePurchasesCheckbox).is(':checked');
                    break;
                case 'Purchase Order':
                    isSameAsShipping = $('#po-billing-same-as-shipping').is(':checked');
                    break;
                case 'PayPal':
                    isSameAsShipping = $('#pp-billing-same-as-shipping').is(':checked');
                    break;
                }

                // ensure that the correct form definition is used at the time of
                // registering the user. without this it will assume that the form
                // is for CC, and lose values for PayPal/PO.
                switch (paymentType) {
                    case 'Credit Card': 
                    forms.CreateAccount = getCreateAccountForm(forms.CreditCard.BillingAddress);
                    break;
                case 'Purchase Order':
                    forms.CreateAccount = getCreateAccountForm(forms.PurchaseOrder.BillingAddress);
                    break;
                case 'PayPal':
                    forms.CreateAccount = getCreateAccountForm(forms.PayPal.BillingAddress);
                    break;
                // Begin Customization
                // Terms is available only for B2B users so we didn't need this object
                case 'My Terms':
                    forms.CreateAccount = {};
                    break;
                // End Customization
                }

                var result = collectRequestData(); 
                if (result.validationResult === true) {
                    processOrderRequest = result.data;
                    // Add additional params to the request
                    processOrderRequest['orderId'] = '{orderId}';
                    processOrderRequest['isSameAsShipping'] = isSameAsShipping;
                    processOrderRequest['savePaymentMethod'] = savePaymentMethod;
                    lockProcessButtons();

                    if (createAccountChecked() && !viewModel.userId) {
                        createAccountAndProcessOrder();
                    } else {
                        // Begin Customization
                        OnePageCheckoutExtra.executeQueueRequests(processOrder, paymentType);
                        // End Customization
                    }
                } else {
                    if (result.errors.length > 0) {
                        Roc.UI.displayErrorPopup(result.errors.join('<br />'));
                    } else {
                        Roc.UI.displayErrorPopup('Please correct highlighted errors.');
                    }
                }
            });
    }

    function processOrder(paymentType) {
        return $.proxyRequest({
            url: '/api/order/place',
            data: JSON.stringify(processOrderRequest),
            type: 'PUT',
            dataType: 'json',
            contentType: 'application/json',
            serverCompleteAction: emailSignUp ? 'SignUpEmailUser' : undefined,
            complete: function (xhr) {
                Roc.Logger.info('OnePageCheckout -> processOrder');
                Roc.Logger.info(xhr);

                var resp = xhr.responseJSON || {};
                if (resp.responseCode === 'Success') {
                    Roc.Core.createCookie('confirmation-token', resp.orderId, 1);

                    if (cfg.google && cfg.google.isGoogleAnalyticsEcommerce && cfg.google.analyticsTrackingId) {
                        //Add google analytics tracking
                        RocAnalytics.recordPaymentStep(viewModel.order.items, paymentType, function () {
                            window.location.href = '/checkout/order-confirmation';
                        });
                    } else {
                        window.location.href = '/checkout/order-confirmation';
                    }
                } else {
                    if (resp.redirectToCart) {
                        Roc.Core.createCookie('cart-msg', JSON.stringify(xhr), 1);
                        window.location.href = '/cart';
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                        releaseLockedButtons();
                    }
                }
                return;
            }
        });
    }

    function changeStorePickupPerson(srcEvt, someoneElsePickup) {
        var $recipientContainer = getRecipientContainerByElement(srcEvt);
        $recipientContainer.find('button[data-roc-action*="pickup"]').addClass('btnDefault').removeClass('btnAction');
        $(srcEvt).removeClass("btnDefault").addClass("btnAction");

        var recipientId = $recipientContainer.attr('data-recipient-id');
        var form = forms['Recipient-' + recipientId];

        if (someoneElsePickup) {
            Roc.Forms.clearData(form, true);
        } else {
            var recipient = getRecipientById(recipientId);
            Roc.Forms.populateData(recipient, form);
        }
    }

    function changePickupPersonEvt() {
        var pickupSomeoneElse = 'button[data-roc-action="pickupSomeoneElse"]';
        $(document)
            .off('click', pickupSomeoneElse)
            .on('click', pickupSomeoneElse, function () {
                changeStorePickupPerson(this, true);
            });

        var pickupMyselfSelector = 'button[data-roc-action="pickupMyself"]';
        $(document)
            .off('click', pickupMyselfSelector)
            .on('click', pickupMyselfSelector, function () {
                changeStorePickupPerson(this, false);
            });
    }

    function openPickupLocationDetailsEvt() {
        var selector = 'button[data-roc-action="openStoreDetails"]';
        $(document)
            .off('click', selector)
            .on('click', selector, function () {
                var $recipientContainer = getRecipientContainerByElement(this);
                var recipientId = $recipientContainer.attr('data-recipient-id');
                var recipient = getRecipientById(recipientId);

                Roc.UI.template('pickupLocationDetailsModal-Tmp', recipient.pickupInventoryLocation).then(function (renderedTemplate) {
                    Roc.UI.unblock();
                    Roc.UI.Modal.open(renderedTemplate);
                    var storeLocationMapElement = document.getElementById('storeLocationMap');

                    if (window.RocConfig.google.enableAddressAutocomplete === true) {
                        GoogleMapsLoader.loadApi()
                            .then(function () {
                                var storeLatLng = new google.maps.LatLng(
                                    recipient.pickupInventoryLocation.latitude,
                                    recipient.pickupInventoryLocation.longitude);

                                var map = new google.maps.Map(storeLocationMapElement,
                                    {
                                        zoom: 15,
                                        center: storeLatLng
                                    });

                                var marker = new google.maps.Marker({
                                    position: storeLatLng,
                                    title: recipient.pickupInventoryLocation.name
                                });

                                marker.setMap(map);
                            });
                    } else {
                        //hide google maps container
                        storeLocationMapElement.parentNode.style.display = "none";
                    }
                });
            });
    }

    function saveCCForFuturePurchasesEvt() {
        $(document)
            .off('change.updateSaveCCVisibility', selectors.createAccountCheckbox)
            .on('change.updateSaveCCVisibility', selectors.createAccountCheckbox, function () {
                updateSaveCCForFuturePurchasesDisplay();
            });
    }

    function bindEvents() {
        if (viewModel.enableShipping) {
            recipientSelectedAddressEvt();
            recipientWantsEditAddressBookEvt();
            recipientSavesChangesForAddressBookEvt();
            recipientCancelsUpdatingAddressBookEvt();
            recipientWantsProvideNewAddressEvt();
            recipientSelectedShippingMethodEvt();
            recipientSelectedShippingPaymentMethodEvt();
            selectedPaymentMethodEvt();
            // Begin Customization
            updateRecipientsAfterChangingPaymentEvt();
            // End Customization
        }

        openPickupLocationDetailsEvt();
        changePickupPersonEvt();

        paymentMethodSelectedEvt();
        paymentTypeSelectedEvt();
        sameBillingAddressEvt();
        saveCCForFuturePurchasesEvt();

        Users.PaymentMethods.bindCheckoutEvents({
            openFormCallback: function () {
                Roc.UI.scrollTo(viewModel.paymentMethods.formPannelSelector, -60);
                unSelectPaymentMethod();
            },

            submitFormCallback: function (dataPayment) {
                selectPaymentMethod(dataPayment.id);
                RocAnalytics.recordCheckoutOption(3, 'Payment Added - ' + dataPayment.cardName);
            }
        });

        Users.PurchaseOrder.bindCheckoutEvents();
        PayPal.bindCheckoutEvents();

        processOrderEvt();
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_SHIPPING_DETAILS, shippingRecalculated);

        $(document)
            .off('change', selectors.saveCCForFuturePurchasesCheckbox)
            .on('change', selectors.saveCCForFuturePurchasesCheckbox, function () {                
                var $formBtns = $(selectors.paymentMethodFormActionButtons);
                if ($(this).is(':checked')) {
                    $formBtns.show();
                } else {
                    $formBtns.hide();
                }
            });

        signInBtnEvt();
        loginUserEvt();
        logoutUserEvt();
        createAccountEvt();
        forgotPasswordEvt();
        GiftCards.bindEvents();

        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, function (response) {
            if (response) {
                viewModel.order.modifiedOrderTotal = response.modifiedOrderTotal;
                viewModel.order.giftCardPayments = response.giftCardPayments;
                reloadPaymentStep(viewModel);
            }
        });

        Roc.EventManager.bind(Roc.Events.giftCards.ASSOCIATE_PAYMENT, function (response) {
            if (response.orderCart) {
                Roc.EventManager.notify(Roc.Events.cart.GET_CURRENT_CART, response.orderCart);
                RocAnalytics.recordCheckoutOption(2, 'Gift Card Added');
            }
        });
        Roc.EventManager.bind(Roc.Events.giftCards.REMOVE_PAYMENT, function (response) {
            if (response.orderCart) {
                Roc.EventManager.notify(Roc.Events.cart.GET_CURRENT_CART, response.orderCart);
                RocAnalytics.recordCheckoutOption(2, 'Gift Card Removed');
            }
        });

        Roc.EventManager.bind(Roc.Events.address.OPEN_BILLING_FORM, function () {
            updateSameAsShippingDisplay();
        });
    }

    function prepareRecipientViewModel(recipient, index) {
        switch (recipient.itemsDeliveryType) {
        case 'Shipping':
            recipient.addressBook = _.cloneDeep(viewModel.addresses);
            recipient.countries = _.cloneDeep(_.filter(viewModel.countries, { 'enableShipping': true }));
            recipient.states = _.cloneDeep(_.filter(viewModel.states, { 'enableShipping': true }));

            if (recipient.addressBook) {
                recipient.displayAddressBookEntries = true;
                if (recipient.shippingAddressId) {
                    var selectedAddress = _.find(recipient.addressBook, { 'id': recipient.shippingAddressId });
                    if (selectedAddress) {
                        selectedAddress.isSelected = true;
                    }
                }
            } else {
                recipient.displayAddressBookEntries = false;
            }

            prepareRecipientShippingOptionsViewModel(recipient);
            break;
        }

        prepareRecipientRecalculateErrors(recipient, viewModel.recipientRecalculateErrors);
        FreightCollect.buildRecipientViewModel(recipient, viewModel.isLoggedIn);
        initializeFormDefinitonsForRecipient(recipient, index);
    }

    function buildViewModel(model) {
        if (model.errors && model.errors.length > 0) {
            redirectToCart({
                errors: model.errors,
                message: model.message
            });
            return;
        }

        viewModel = model;

        viewModel.billingAddress = _.find(viewModel.addresses, function (address) {
            return address.customFields && address.customFields.externalId === "0"
        });

        if (!viewModel.billingAddress) {
            viewModel.billingAddress = _.find(viewModel.addresses, function (address) {
                return address.isOrganizationAddress === true || address.enableBilling === true;
            });
        }

        if (viewModel.enableShipping) {
            // prepare address book entries before displaying
            _.forEach(viewModel.addresses, function (address) {
                address.btnUseThis = buttons.address.btns.btnUseThis;
                address.btnSelected = buttons.address.btns.btnSelected;
            });

            FreightCollect.init();

            // populate address book data for each recipient
            _.forEach(viewModel.order.recipients, function (recipient, index) {
                if (recipient.itemsDeliveryType !== 'Virtual') {
                    prepareRecipientViewModel(recipient, index);
                }
            });
        }

        viewModel.purchaseOrder = Users.PurchaseOrder.initCheckout(_.cloneDeep(model));
        viewModel.purchaseOrder.displaySameAsShippingAddress = model.displaySameAsShippingAddress;

        viewModel.paymentMethods = Users.PaymentMethods.initCheckout(_.cloneDeep(model));
        viewModel.paymentMethods.isCheckout = true;
        viewModel.paymentMethods.displaySameAsShippingAddress = model.displaySameAsShippingAddress;

        viewModel.payPal = PayPal.initCheckout(_.cloneDeep(model));
        viewModel.payPal.displaySameAsShippingAddress = model.displaySameAsShippingAddress;
        viewModel.isPayPalEnabled = _.findIndex(viewModel.paymentTypes, { 'name': 'PayPal' }) !== -1;

        viewModel.terms = Terms.initCheckout(_.cloneDeep(model), viewModel.billingAddress, viewModel.paymentTypes);

        if (viewModel.isPayPalEnabled) {
            if (!viewModel.payPal.isAccepted) {
                // if paypal transaction is not accepted by the user
                // but paypal is enabled then remove paypal from options
                // so it doesn't get displayed in the dropdown. 
                // PayPal Express Checkout buttons is displayed in this case
                _.remove(viewModel.paymentTypes, { 'name': 'PayPal' });
                if (viewModel.paymentTypes.length === 1) {
                    viewModel.displayPaymentMethodSelector = false;
                }
            }
        }

        $.each(viewModel.paymentTypes, function (index, value) {
            value.isSelected = value.name === viewModel.selectedPaymentType;
            value.btnUseThis = buttons.payment.btns.btnUseThis;
            value.btnSelected = buttons.payment.btns.btnSelected;
            if (value.paymentType === "PurchaseOrder") {
                viewModel.displayPaymentMethodSelector = true;
                value.btnUseThis.text = "Bill My Saf-T-Gard Account";
                value.btnSelected.text = "Bill My Saf-T-Gard Account";
            }
        });

        viewModel.disableNewsletterSignUp = viewModel.userSubscribed && viewModel.isLoggedIn;

        // Begin Customization
        forms.PoNumber = OnePageCheckoutExtra.forms.poNumber;
        forms.orderNotes = OnePageCheckoutExtra.forms.orderNotes;
        // End Customization

        //Purchase order forms group:
        forms.PurchaseOrder = {
            PurchaseOrder: viewModel.purchaseOrder.forms.purchaseOrder,
            BillingAddress: viewModel.purchaseOrder.forms.billingAddress,
            selectedBillingAddress: viewModel.purchaseOrder.forms.selectedBillingAddress,
            isGroup: true
        };
        forms.PurchaseOrder.BillingAddress.RequestParam = 'billingAddress';

        //Credit card forms group
        forms.CreditCard = {
            BillingAddress: viewModel.paymentMethods.forms.billingAddress,
            AddPaymentMethod: viewModel.paymentMethods.forms.paymentMethod,
            selectedBillingAddress: viewModel.paymentMethods.forms.selectedBillingAddress,
            isGroup: true
        };

        //PayPal forms group
        forms.PayPal = {
            PayPal: viewModel.payPal.forms.payPal,
            BillingAddress: viewModel.payPal.forms.billingAddress,
            selectedBillingAddress: viewModel.payPal.forms.selectedBillingAddress,
            isGroup: true
        }; 
        //Terms forms group:
        forms.Terms = {
            Terms: viewModel.terms.forms.terms,
            BillingAddress: viewModel.terms.forms.billingAddress,
            selectedBillingAddress: viewModel.terms.forms.selectedBillingAddress,
            selectedPoDocument: viewModel.terms.forms.selectedPoDocument,
            isGroup: true
        };

        forms.PayPal.BillingAddress.RequestParam = 'billingAddress';
        forms.CreditCard.BillingAddress.RequestParam = 'billingAddress';
        forms.CreditCard.AddPaymentMethod.RequestParam = 'creditCardData';

        forms.RecipientEmail = getEmailForm();

        recipientContainers = {};
        viewModel.isBillingSameAsShipping = false;

        // Record Checkout page initial landing to to Analytics
        RocAnalytics.recordCheckoutStep(viewModel.order.items, 2, false);
        RocAnalytics.recordCheckoutStep(viewModel.order.items, 3, false);
        var shippingMethod = 'Shipping';


        for (var i = 0; i < viewModel.order.recipients.length; i++) {
            var recipient = viewModel.order.recipients[i];
            recipient.country = recipient.country || window.RocConfig.defaultCountryCode;
            recipient.defaultCountryCode = window.RocConfig.defaultCountryCode;
            recipient.enableInternationalShipping = window.RocConfig.shipping.enableInternationalShipping;
        }

        Roc.UI.renderFormTemplate('onePageCheckout-Tmp', viewModel, $('#onePageCheckoutWrapper')).then(function () { 
            viewRendered();
            bindEvents();
            // Begin Customization
            OnePageCheckoutExtra.bindEvents(); 
            displayPaymentForm(viewModel.selectedPaymentType);
            // End Customization
        });
    }

    function init(model) {
        buildViewModel(model);
    }

    var OnePageCheckout = {
        init: init
    };

    Roc.Logger.debug('OnePageCheckout.js Loaded:', OnePageCheckout);

    return OnePageCheckout;
});
